import { render, staticRenderFns } from "./TopPrints.vue?vue&type=template&id=7fef9c72&scoped=true&"
import script from "./TopPrints.vue?vue&type=script&lang=js&"
export * from "./TopPrints.vue?vue&type=script&lang=js&"
import style0 from "./TopPrints.vue?vue&type=style&index=0&id=7fef9c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef9c72",
  null
  
)

export default component.exports